<template>
  <!-- <v-img thumbnail fluid :src="image" v-show="validate(image)"></v-img> -->
  <v-img v-if="image" :src="image"></v-img>
</template>

<script>
  export default {
    name: 'image-preview',
    computed: {
      image() {
        return this.$store.state.uploader.image;
      }
    },
    methods: {
      validate(img) {
        return img && (img.match(/jpg|gif|png|jpeg/) || img.match(/^data:image/))
      }
    },
    mounted() {
      return this.validate(this.image) ? this.show = true : this.show = false;
    }
  }
</script>
